export default __webpack_public_path__ + "static/media/89.ccd77c29.jpeg";